import React, { useMemo } from 'react';
import DayPicker from 'react-day-picker';
import InfoIcon from '../../../../assets/svg/infoIcon';
import { addDay, getDateAfterDays, getDateAfterMonth, monthDiffernce } from '../../utils';
import ModifySearchHeader from '../../ModifySearchHeader';
import './DatePicker.css';
import 'react-day-picker/lib/style.css';

const DatePicker = ({
  value,
  handleChange,
  numberOfMonths = 2,
  renderDay,
  disableDates,
  minDate,
  maxDate,
  destinationCity,
  listingDateData,
  handleClose,
}) => {
  const selectedDate = value || getDateAfterDays(0);
  const typeOfCalendar = window.innerWidth < 768 ? 12 : 2;

  const [disabledDays, fromMonth, toMonth] = useMemo(() => {
    const { availableDates = [] } = listingDateData || {};
    if (disableDates) {
      return [disableDates, minDate, maxDate, numberOfMonths];
    }
    if (availableDates.length) {
      const sortedData = availableDates.sort((a, b) => (a.start > b.start ? 1 : -1));
      const typeOfCalendar = Math.min(monthDiffernce(sortedData), numberOfMonths);
      const dates = [];
      const fromDate = new Date();
      let toDate = new Date();
      dates[0] = {};
      const currDate = new Date();
      dates[0].from = new Date(currDate.getFullYear(), currDate.getMonth(), 1);
      dates[0].to = addDay(new Date(sortedData[0].start), -1);

      for (let i = 1; i < sortedData.length; i++) {
        const { end: first } = sortedData[i - 1];
        const { start: second } = sortedData[i];
        dates[i] = {};
        dates[i].from = addDay(new Date(first), 1);
        dates[i].to = addDay(new Date(second), -1);
      }
      const last = dates.length;
      const [year, mon] = sortedData[sortedData.length - 1].end.split('-');
      dates[last] = {};
      dates[last].from = addDay(new Date(sortedData[sortedData.length - 1].end), 1);
      dates[last].to = new Date(year, mon, 0);
      if (toDate < dates[dates.length - 1].to) {
        toDate = dates[dates.length - 1].to;
      }
      return [dates, fromDate, toDate, typeOfCalendar];
    }
    return [
      [
        {
          before: getDateAfterDays(2, destinationCity),
          after: getDateAfterMonth(11),
        },
      ],
      getDateAfterMonth(0),
      getDateAfterMonth(11),
      numberOfMonths,
    ];
  }, [listingDateData]);
  const isMobile = window.innerWidth < 768;

  return (
    <div
      className={`daypicker-container ${typeOfCalendar === 1 ? 'small' : ''} ${
        isMobile ? 'mobile-view' : ''
      }`}
    >
      {listingDateData?.msg?.length > 0 && (
        <p className="latoBlack message-strip">
          <span>{<InfoIcon />}</span>
          <span className="message">{listingDateData?.msg}</span>
        </p>
      )}
      <DayPicker
        initialMonth={selectedDate}
        selectedDays={value}
        onDayClick={handleChange}
        disabledDays={disabledDays}
        fromMonth={fromMonth}
        toMonth={toMonth}
        numberOfMonths={typeOfCalendar}
        renderDay={renderDay}
        showNextButton={!isMobile}
        showPreviousButton={!isMobile}
      />
    </div>
  );
};

export default DatePicker;
